var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoOperacoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.39,
    height: 50.39,
    viewBox: "0 0 50.39 50.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2",
    x1: -998.43,
    y1: 392.92,
    x2: -998.43,
    y2: 393.92,
    gradientTransform: "matrix(50.39, 0, 0, -50.39, 50332.08, 19848.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#674a98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0db1d3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-operacoes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2649",
    "data-name": "Grupo 2649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ico-operacoes-2",
    d: "M47.14,6.5h-6.5V4.88a1.63,1.63,0,0,0,1.62-1.63V1.62A1.63,1.63,0,0,0,40.63,0h-39A1.63,1.63,0,0,0,0,1.62V3.25A1.63,1.63,0,0,0,1.62,4.88V21.59L0,20.06V50.39H32.11L9.74,29.26H32.51V43.07A2.44,2.44,0,0,0,35,45.51H48a2.43,2.43,0,0,0,2.43-2.44V21.94A2.43,2.43,0,0,0,48,19.5H40.63V14.63h6.5a3.26,3.26,0,0,0,3.26-3.25V9.75A3.26,3.26,0,0,0,47.14,6.5ZM24.38,12.3l-2.6-1.73,2.6-1.74ZM26,11.38H43.89V13H26ZM43.89,9.75H26V8.13H43.89ZM1.62,1.62h39V3.25h-39Zm0,47.14V47.14H3.25V45.51H1.62V43.89H3.25V42.26H1.62V40.63H3.25V39H1.62V37.38H3.25V35.76H1.62V34.13H3.25V32.51H1.62V30.88H3.25V29.26H1.62V23.83L28,48.76ZM48.76,21.94V43.07a.82.82,0,0,1-.81.82H35a.82.82,0,0,1-.81-.82V21.94a.81.81,0,0,1,.81-.81H48A.81.81,0,0,1,48.76,21.94ZM39,19.5H25.19v1.63h7.47a2.28,2.28,0,0,0-.15.81v.82H25.19v1.62h7.32v3.25H8l-4.77-4.5V4.88H39V6.5H25l-6.1,4.06L25,14.63H39Zm9.75-8.13A1.63,1.63,0,0,1,47.14,13H45.51V8.13h1.63a1.63,1.63,0,0,1,1.62,1.62Zm-31.7,0H12.9L11.12,24.75,6.92,19.5h-2V17.88H7.7L10,20.76l1.46-11h5.59Zm6.27,3.83-3.49,3.49,3.49,3.49-1.15,1.15-3.49-3.49L15.2,23.33l-1.15-1.15,3.49-3.49L14.05,15.2l1.15-1.15,3.49,3.49,3.49-3.49Zm14.05,2.68H25.19V16.25H37.38ZM4.88,31.37V45.51h15ZM6.5,35.14l9.26,8.74H6.5ZM47.14,22.76H35.76v6.5H47.14Zm-1.63,4.87H37.38V24.38h8.13Zm-3.25,4.88h4.88v1.62H42.26ZM40.63,39H35.76V37.38h4.87Zm0,3.25H35.76V40.63h4.87Zm-3.25-8.13H35.76V32.51h1.62V30.88H39v1.63h1.62v1.62H39v1.63H37.38Zm9.52,4.64-1,1,1,1L45.75,42,44.7,41,43.65,42,42.5,40.87l1-1-1-1,1.15-1.15,1.05,1.05,1-1.05Z",
    style: {
      fill: "url(#Gradiente_sem_nome_2)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOperacoes);
export default __webpack_public_path__ + "static/media/ico-operacoes.55ee50cec5d69526a0fdd4718c3789fc.svg";
export { ForwardRef as ReactComponent };